export const generalState = {
    selectedWorkspace: undefined,
    statusLoginSpinner: false,
};
